module.exports = __webpack_public_path__ + "img/ico_lianxiren_fasong.a5f80081.png";